import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';

const TagsSelector = ({
  onChanged,
  isMulti,
  selectedId,
}) => {
  const { tagsList } = useSelector(state => state.tags);
  const citiesOptions = tagsList.map(tag => ({
    label: `${tag.name}`,
    value: tag.id,
  }));
  let selectedItem;
  if (selectedId) {
    if (Array.isArray(selectedId)) {
      selectedItem = citiesOptions.filter(x => Array.from(selectedId).includes(x.value));
    } else {
      selectedItem = citiesOptions.find(x => x.value === selectedId);
    }
  }
  return (
    <Select
      options={citiesOptions}
      value={selectedItem}
      placeholder="Select Tag..."
      isMulti={isMulti}
      onChange={(item) => {
        if (onChanged) {
          onChanged(item);
        }
      }}
    />
  );
};

TagsSelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedId: PropTypes.any,
};

TagsSelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedId: undefined,
};

export default TagsSelector;
